/**
 * This module provides utility functions for device detection.
 * It includes functions to check if the current device is a touch device and if the current browser is Firefox.
 */
/**
 * Checks if the current device is a touch device.
 *
 * @returns {boolean} - `true` if the current device is a touch device, `false` otherwise.
 */
export const isTouchDevice = () => 'ontouchstart' in window;
/**
 * Checks if the current browser is Firefox.
 *
 * @returns {boolean} - `true` if the current browser is Firefox, `false` otherwise.
 */
export const isFirefox = () => navigator.userAgent.includes('Firefox');
//# sourceMappingURL=device-detection.js.map